// import Assignment from './Assignment';

export default {
  // component: Assignment,
  component: load(() => import(/* webpackChunkName: "Permission-Role-Assignment" */ './Assignment')),
  priority: 10,
  permissions: ['BasicInformationMenu/Permissions/RolesMenu/AssignPermissionsMenu'], // TODO permissions Assignment
  name: app.translate('routes.home.basic.permission.Assignment'),
  icon: 'account-check',
  drawer: true,
};
